import FingerprintJS from "@fingerprintjs/fingerprintjs";

let promise: Promise<string> | null = null;

export function getFingerprint(): Promise<string> {
  if (!promise) {
    promise = FingerprintJS.load()
      .then(fp => fp.get())
      .then(result => result.visitorId);
  }
  return promise;
}
